import Api from '../Api';

import { url } from './config';
import { Market } from './types';

const api = new Api<Market>(url);

export default api;
